import {BaseContainerModel} from '../base-container.model';
import {bl_mrp_prodsys_link_RowClass} from '../../dbschema';

export class MrpProdsysLinkContainerModel extends BaseContainerModel {
    bl_mrp_prodsys_link: bl_mrp_prodsys_link_RowClass = new bl_mrp_prodsys_link_RowClass();
}
